import {formatDateForCookies} from "@js/utils/formatter";

export const isDate = (date) =>
    Object.prototype.toString.call(date) === "[object Date]";

export const isDifferentDates = (date1, date2) => {
    return formatDateForCookies(date1) !== formatDateForCookies(date2);
};


export const sameDayPreviousYear = (d) => {
    const t = new Date(+d);
    const startDayNum = d.getDay();

    t.setFullYear(t.getFullYear() - 1);

    let diff = startDayNum - t.getDay();

    diff = diff > 3 ? diff - 7 : diff;
    t.setDate(t.getDate() + diff);

    return t;
};
